import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download, Check, Gift } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function PricingCTA() {
  const handleBuyClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Semana Resuelta PDF',
      content_type: 'product',
      value: 9990,
      currency: 'ARS'
    });
  };
  return <Section className="pb-24" id="pricing" data-id="element-107">
      <div className="bg-white rounded-3xl shadow-xl border border-stone-100 overflow-hidden" data-id="element-108">
        <div className="bg-sage-light/30 p-8 md:p-12 text-center" data-id="element-109">
          <div className="inline-block px-4 py-1 mb-4 text-sm font-bold tracking-wider text-amber uppercase bg-amber/10 rounded-full" data-id="element-110">
            Oferta de lanzamiento
          </div>

          <div className="flex flex-col items-center gap-1 mb-6" data-id="element-111">
            <div className="flex items-baseline gap-2" data-id="element-112">
              <span className="text-2xl font-bold text-brown-body/40 line-through" data-id="element-113">
                $14.990
              </span>
            </div>
            <div className="flex items-baseline gap-1" data-id="element-114">
              <span className="text-2xl font-bold text-brown-body/60" data-id="element-115">$</span>
              <span className="text-6xl font-bold text-brown-heading" data-id="element-116">
                9.990
              </span>
              <span className="text-lg font-medium text-brown-body/60" data-id="element-117">
                ARS
              </span>
            </div>
          </div>

          <div className="max-w-sm mx-auto mb-8 text-left" data-id="element-118">
            <div className="space-y-2.5" data-id="element-119">
              <div className="flex items-center gap-3" data-id="element-120">
                <div className="w-5 h-5 rounded-full bg-sage text-white flex items-center justify-center flex-shrink-0" data-id="element-121">
                  <Check className="w-3 h-3" strokeWidth={3} data-id="element-122" />
                </div>
                <span className="font-bold text-brown-heading" data-id="element-123">
                  Semana Resuelta (PDF principal)
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-124">
                <div className="w-5 h-5 rounded-full bg-amber/20 text-amber flex items-center justify-center flex-shrink-0" data-id="element-125">
                  <Gift className="w-3 h-3" strokeWidth={3} data-id="element-126" />
                </div>
                <span className="text-brown-body" data-id="element-127">
                  Bono 1: Domingo Cerrado{' '}
                  <span className="text-xs font-bold text-sage-dark" data-id="element-128">
                    (GRATIS)
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-129">
                <div className="w-5 h-5 rounded-full bg-amber/20 text-amber flex items-center justify-center flex-shrink-0" data-id="element-130">
                  <Gift className="w-3 h-3" strokeWidth={3} data-id="element-131" />
                </div>
                <span className="text-brown-body" data-id="element-132">
                  Bono 2: Swaps Inteligentes{' '}
                  <span className="text-xs font-bold text-sage-dark" data-id="element-133">
                    (GRATIS)
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-134">
                <div className="w-5 h-5 rounded-full bg-amber/20 text-amber flex items-center justify-center flex-shrink-0" data-id="element-135">
                  <Gift className="w-3 h-3" strokeWidth={3} data-id="element-136" />
                </div>
                <span className="text-brown-body" data-id="element-137">
                  Bono 3: Salvavidas 10 Min{' '}
                  <span className="text-xs font-bold text-sage-dark" data-id="element-138">
                    (GRATIS)
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-3 mb-8" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/peVSuXdDcbnfaxYRVaTA8b/Bono_1.png" alt="Bono 1: Domingo Cerrado" className="w-24 md:w-28 rounded-lg shadow-md" data-id="element-140" />
            <img src="https://cdn.magicpatterns.com/uploads/h5E2Nkedj9P1EqP7YQ37d7/Bono_2.png" alt="Bono 2: Swaps Inteligentes" className="w-24 md:w-28 rounded-lg shadow-md" data-id="element-141" />
            <img src="https://cdn.magicpatterns.com/uploads/mHwfronhHkQVTkoJ4tGHU4/Bono_3.png" alt="Bono 3: Salvavidas 10 Min" className="w-24 md:w-28 rounded-lg shadow-md" data-id="element-142" />
          </div>

          <div className="space-y-2 mb-10 text-brown-body" data-id="element-143">
            <p data-id="element-144">
              Es menos que una compra improvisada que después te deja con culpa.
            </p>
            <p className="font-medium" data-id="element-145">
              Y mucho menos que el costo mental de decidir comida todos los
              días.
            </p>
          </div>

          <Button href="https://argrutinas.com/cart/42965772992721:1" onClick={handleBuyClick} className="w-full md:w-auto text-xl font-bold px-10 py-5 shadow-xl shadow-sage/20 mb-6" data-id="element-146">
            Hacé clic y descargalo ahora
            <Download className="ml-2 w-6 h-6" data-id="element-147" />
          </Button>

          <p className="text-sm text-brown-body/70 max-w-md mx-auto" data-id="element-148">
            Hoy mismo podés cerrar tu semana en 30 minutos y dejar de pelearte
            con la heladera.
          </p>
        </div>

        <div className="bg-stone-50 p-6 text-center border-t border-stone-100" data-id="element-149">
          <p className="text-xs text-stone-500 max-w-2xl mx-auto leading-relaxed" data-id="element-150">
            Disclaimer: Este producto es educativo y de organización. No
            reemplaza consejo médico. Si tomás medicación, consultá ante cambios
            importantes.
          </p>
        </div>
      </div>
    </Section>;
}